<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer/table">客户管理({{customer.name}})</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/project/table/${$route.params.customerid}`">项目管理({{project.name}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="实习生成本"
                          prop="trainee_cost">
              <el-input v-model.number="form.trainee_cost">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="线下成本"
                          prop="offline_cost">
              <el-input v-model.number="form.offline_cost">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="开票金额"
                          prop="ticket_amount">
              <el-input v-model.number="form.ticket_amount">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="税金"
                          prop="rate_amount">
              <el-input v-model.number="form.rate_amount">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="收款金额"
                          prop="receipt_amount">
              <el-input v-model.number="form.receipt_amount">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="银行流水"
                          prop="bank_flow_num">
              <el-input v-model="form.bank_flow_num"></el-input>
            </el-form-item>
            <el-form-item label="利息成本"
                          prop="interest_cost">
              <el-input v-model.number="form.interest_cost">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="回款率"
                          prop="return_rate">
              <el-input :value="return_rate"
                        disabled>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="实际毛利"
                          prop="actual_gross_interest">
              <el-input :value="actual_gross_interest"
                        disabled>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="实际毛利率"
                          prop="actual_gross_interest_rate">
              <el-input :value="actual_gross_interest_rate"
                        disabled>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../project-finance.rules.js'

export default {
  components: {},
  data () {
    let checkTotal = 0
    let checkNextField = (field) => {
      checkTotal++
      if (checkTotal === 2) {
        checkTotal = 0
      } else {
        this.$refs.form.validateField(field)
      }
    }
    formRules.ticket_amount[1] = {
      trigger: 'change',
      validator: (rule, value, callback) => {
        let isInput = this.form.rate_amount !== '' && this.form.rate_amount !== null
        if (isInput && Number(value) <= this.form.rate_amount) {
          return callback(new Error('开票金额必须大于税金'))
        }
        isInput > 0 && checkNextField('rate_amount')
        callback()
      },
    }
    formRules.rate_amount[1] = {
      trigger: 'change',
      validator: (rule, value, callback) => {
        let isInput = this.form.ticket_amount !== '' && this.form.ticket_amount !== null
        if (isInput && Number(value) >= this.form.ticket_amount) {
          return callback(new Error('税金必须小于开票金额'))
        }
        isInput && checkNextField('ticket_amount')
        callback()
      },
    }
    return {
      id: 0,
      customer: {
        id: this.$route.params.customerid,
        name: null,
      },
      project: {
        id: this.$route.params.id,
        name: null,
      },
      formRules,
      form: {
        customerid: this.$route.params.customerid,
        'trainee_cost': null,
        'offline_cost': null,
        'ticket_amount': null,
        'rate_amount': null,
        'receipt_amount': null,
        'bank_flow_num': null,
        'interest_cost': null,
        'return_rate': null,
        'actual_gross_interest': null,
        'actual_gross_interest_rate': null,
        // 用于计算实际毛利
        project_cost: null,
      },
    }
  },
  computed: {
    // 回报率 = 收款金额 / 开票金额
    'return_rate' () {
      let form = this.form
      this.form.return_rate = 0
      if (form.receipt_amount && form.ticket_amount) {
        this.form.return_rate =
          filter.toFixed(
            form.receipt_amount /
            form.ticket_amount *
            100,
            2,
          )
      }
      return this.form.return_rate
    },
    // 实际毛利 = 开票金额 - 实习生成本 - 线外成本 - 利息成本 - 税金 - 项目成本
    'actual_gross_interest' () {
      let form = this.form
      this.form.actual_gross_interest =
        filter.toFixed(
          form.ticket_amount -
          form.trainee_cost -
          form.offline_cost -
          form.interest_cost -
          form.rate_amount -
          form.project_cost,
          2,
        )
      return this.form.actual_gross_interest
    },
    // 实际毛利率 = 实际毛利/(开票金额-税金)
    'actual_gross_interest_rate' () {
      let form = this.form
      this.form.actual_gross_interest_rate = null
      if (form.ticket_amount > form.rate_amount) {
        this.form.actual_gross_interest_rate =
          filter.toFixed(
            form.actual_gross_interest /
            (
              form.ticket_amount -
              form.rate_amount
            ) * 100,
            2,
          )
      }
      return this.form.actual_gross_interest_rate
    },
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
      this.setCustomer()
      this.setProject()
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getProjectFinanceDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createProjectFinanceData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/project/table' + this.$route.params.customerid})
        })
      })
    },
    update (id) {
      request.common('updateProjectFinanceData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/project/table/' + this.$route.params.customerid})
        })
      })
    },
    setCustomer () {
      if (!this.customer.name) {
        request.common('getCustomerDetail', {id: this.$route.params.customerid}).then(({data}) => {
          this.customer = data
        })
      }
    },
    setProject () {
      if (!this.project.name) {
        request.common('getProjectDetail', {id: this.$route.params.id}).then(({data}) => {
          this.project = data
        })
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer-project/pages/ProjectFinanceForm.vue